export const MRKT_ATTR__UTM__SOURCE = 'utm_source';
export const MRKT_ATTR__MP_DISTINCT_ID = 'distinct_id_mp';
export const MRKT_ATTR__UTM_CAMPAIGN = 'utm_campaign';
export const MRKT_ATTR__REF_PAGE = 'ref_page';
export const MRKT_ATTR__SITE_NAME = 'codespark';



// WEBPACK FOOTER //
// ./src/constants/marketing.js